import { listType } from "./index";

export const useFilterGold = (ctmarketlist, activeListType) => {
  let filterList = [];
  if (activeListType.value === listType.enum.coin) {
    filterList = ctmarketlist.filter((item) => item.coinType === 1);
  }

  if (activeListType.value === listType.enum.rate) {
    filterList = ctmarketlist.filter((item) => item.coinType === 2);
  }

  if (activeListType.value === listType.enum.gold) {
    filterList = ctmarketlist.filter((item) => item.coinType === 3);
  }

  const filterActionObj = (obj) => {
    const filterObj = Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => {
        if (filterList.map((item) => item.coinname).includes(key)) {
          return true;
        }
        return false;
      })
    );

    return filterObj;
  };

  const filterActionArray = (arr) => {
    return arr.filter((item) => {
      if (filterList.map((item) => item.coinname).includes(item.coinname)) {
        return true;
      }
      return false;
    });
  };

  const filterAction = (data) => {
    if (Array.isArray(data)) {
      return filterActionArray(data);
    }
    return filterActionObj(data);
  };

  return {
    filterAction,
  };
};
